/* fileConstants.js */

"use strict";

const FILE_TYPE_FILTER = {
    AES: {
        extension: "aes",
        description: "aes encrypted file",
        "mime-types": [],
    },
    BIN: {
        extension: "bin",
        description: "binary archive",
        "mime-types": ["application/octet-stream", "application/x-binary"],
    },
    FLASH: {
        extension: "flash",
        description: "flash file",
        "mime-types": [],
    },
    IMG: {
        extension: "img",
        description: "disk image",
        "mime-types": [],
    },
    ISO: {
        extension: "iso",
        description: "iso disk image",
        "mime-types": ["application/x-iso9660-image"],
    },
    MD5: {
        extension: "md5",
        description: "md5 encrypted file",
        "mime-types": [],
    },
    OUT: {
        extension: "out",
        description: "out file",
        "mime-types": [],
    },
    OVA: {
        extension: "ova",
        description: "ovf package",
        "mime-types": [],
    },
    PACK: {
        extension: "pack",
        description: "packed jar file",
        "mime-types": [],
    },
    PKG: {
        extension: "pkg",
        description: "installer package",
        "mime-types": [],
    },
    SHA256: {
        extension: "sha256",
        description: "sha256 encrypted file",
        "mime-types": [],
    },
    SPA: {
        extension: "spa",
        description: "spa file",
        "mime-types": [],
    },
    SSA: {
        extension: "ssa",
        description: "ssa file",
        "mime-types": [],
    },
    TAR: {
        extension: "tar",
        description: "tar archive",
        "mime-types": [
            "application/tar",
            "application/x-tar",
            "multipart/x-tar",
            "application/x-compress",
        ],
    },
    TGZ: {
        extension: "tgz",
        description: "gzip compressed tar archive",
        "mime-types": ["application/gnutar", "application/x-gtar"],
    },
    ZIP: {
        extension: "zip",
        description: "zip compressed archive",
        "mime-types": [
            "application/zip",
            "application/octet-stream",
            "application/x-zip-compressed",
            "multipart/x-zip",
        ],
    },
};

const getFileType = (extension, mimeType) => {
    extension = String(extension).toLocaleLowerCase();
    const typeEntries = Object.entries(FILE_TYPE_FILTER);
    let typeEntry =
        typeEntries.find(([, typeObj]) => typeObj.extension === extension) ||
        typeEntries.find(([, typeObj]) => typeObj["mime-types"].includes(mimeType));

    return typeEntry && typeEntry[0];
};

module.exports = {
    FILE_TYPE_FILTER,
    getFileType,
};
